export default "/_next/static/images/2-95410f26016a32319913c96883a42fff.png";